import { tooltipAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react";

export const tooltipRecipe = defineSlotRecipe({
  slots: tooltipAnatomy.keys(),
  base: {
    content: {
      display: "flex",
      alignItems: "center",
      px: 2,
      py: 1,
      borderRadius: "md",
      fontSize: "xs",
      fontWeight: "medium",
      boxShadow: "md",
      bg: "neutral.50",
      color: "neutral.700",
      maxW: "xs",
      zIndex: 1000,
    },
    arrow: {
      fill: "neutral.50",
      boxSize: "6px",
    },
    arrowTip: {
      fill: "neutral.50",
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px",
      borderColor: "neutral.50",
    },
  },
  variants: {
    visual: {
      // dark, light, primary, secondary, success, warning, danger
      default: {
        content: {
          bg: "neutral.900",
          color: "neutral.50",
        },
        arrow: {
          fill: "neutral.900",
        },
        arrowTip: {
          fill: "neutral.900",
        },
      },
      primary: {
        content: {
          bg: "primary.500",
          color: "white",
        },
        arrow: {
          fill: "primary.500",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderInlineStartWidth: "1px",
          borderColor: "primary.500",
        },
      },
      secondary: {
        content: {
          bg: "secondary.500",
          color: "white",
        },
        arrow: {
          fill: "secondary.500",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderInlineStartWidth: "1px",
          borderColor: "secondary.500",
        },
      },
      success: {
        content: {
          bg: "green.500",
          color: "white",
        },
        arrow: {
          fill: "green.500",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderInlineStartWidth: "1px",
          borderColor: "green.500",
        },
      },
      warning: {
        content: {
          bg: "orange.500",
          color: "white",
        },
        arrow: {
          fill: "orange.500",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderInlineStartWidth: "1px",
          borderColor: "orange.500",
        },
      },
      danger: {
        content: {
          bg: "red.500",
          color: "white",
        },
        arrow: {
          fill: "red.500",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderInlineStartWidth: "1px",
          borderColor: "red.500",
        },
      },
    },
    size: {
      xs: {
        content: {
          px: 1.5,
          py: 0.5,
          fontSize: "2xs",
        },
      },
      sm: {
        content: {
          px: 2,
          py: 1,
          fontSize: "xs",
        },
      },
      md: {
        content: {
          px: 2.5,
          py: 1.5,
          fontSize: "sm",
        },
      },
      lg: {
        content: {
          px: 3,
          py: 2,
          fontSize: "md",
        },
      },
    },
  },
  // defaultVariants: {
  //   visual: "default",
  //   size: "sm",
  // },
});
